import Model from './Model'

export class StarPrinter extends Model {
	/** @var string */ port
	/** @var string */ model
	/** @var string */ emulator
	/** @var boolean */ enabled = false
	/** @var number */ copies   = 1

	constructor(payload) {
		super()
		this.port     = payload.portName || payload.port
		this.model    = payload.modelName || payload.model
		this.emulator = this.model.includes('TSP1')? 'StarGraphic' : 'StarLine'

		if (typeof payload.enabled != 'undefined') {
			this.enabled = payload.enabled
		}
		if (typeof payload.copies != 'undefined') {
			this.copies = payload.copies
		}
	}
}
